module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-daterange form-group row"
  }, [_c('div', {
    staticClass: "input-date-time-picker"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myStartDate),
      callback: function($$v) {
        _vm.myStartDate = $$v
      },
      expression: "myStartDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelStartTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndDate[_vm.actualLanguage]))]), _vm._v(" "), _c('date-picker', {
    staticClass: "el-input__inner form-control",
    attrs: {
      "type": "date",
      "placeholder": "",
      "clear-icon": "",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.myEndDate),
      callback: function($$v) {
        _vm.myEndDate = $$v
      },
      expression: "myEndDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startDateTime"
    }
  }, [_vm._v(_vm._s(_vm.labelEndTime[_vm.actualLanguage]))]), _vm._v(" "), _c('time-select', {
    attrs: {
      "placeholder": "",
      "clear-icon": "",
      "picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelDataSamplingTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataSamplingSelect),
      expression: "dataSamplingSelect"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataSamplingSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Automatic"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingAuto[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5min"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSampling5min[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Hour"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingHour[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Day"
    }
  }, [_vm._v(_vm._s(_vm.labelDataSamplingDays[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.refreshGraph()
      }
    }
  }, [(_vm.flagGraphDataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-repeat pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonRefresh[_vm.actualLanguage]))])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-bolt fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text"
  }, [_vm._v(_vm._s(_vm.labelGraphPeakCurrent[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h4 font-w700"
  }, [_vm._v(_vm._s(_vm.maxCurrent) + " "), _c('span', {
    staticClass: "h4 text"
  }, [_vm._v("A")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-money fa-3x text-success"
  }), _vm._v(" "), (_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.iconFile === 'SolarPanel.png') ? _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelGraphSaving[_vm.actualLanguage]))])]) : _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelGraphCost[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h4 font-w700"
  }, [_vm._v(_vm._s(_vm.sumCost) + "$ "), _c('span', {
    staticClass: "h4 text-muted"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-download fa-3x text-success"
  }), _vm._v(" "), (_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.iconFile === 'SolarPanel.png') ? _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v("Production")])]) : _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelGraphConsumption[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h4 font-w700"
  }, [_vm._v(_vm._s(_vm.sumKWH) + " "), _c('span', {
    staticClass: "h4 text-muted"
  }, [_vm._v("kWh")])])])])])]), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [(_vm.flagDisplayOldGraphVersion) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDataType),
      expression: "selectedDataType"
    }],
    staticClass: "js-select2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedDataType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeDataForGraph]
    }
  }, [_c('option', {
    attrs: {
      "value": "avrPower"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorAvrPower[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "peak"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorPeakPower[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kwh"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorKWH[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cost"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCost[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cumSumKwh"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCumSumKWH[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cumSumCost"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCumSumCost[_vm.actualLanguage]))])]), _vm._v(" "), _c('line-chart', {
    attrs: {
      "chartData": _vm.crunchedPowerCall
    }
  })], 1), _vm._v(" "), (_vm.profileData.rights.rights.logWeatherFlag) ? _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.showWeatherSelector) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWeatherType),
      expression: "selectedWeatherType"
    }],
    staticClass: "js-select2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedWeatherType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeDataForWeatherGraph]
    }
  }, [(_vm.selectedWeatherType === 'none') ? _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorSelectWeather[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), (_vm.showWeatherGraph) ? _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorUnSelectWeather[_vm.actualLanguage]))]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temperature"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorTemperature[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "humidity"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorHumidity[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cloud"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCloud[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "wind"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorWind[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.showWeatherGraph) ? _c('line-chart', {
    attrs: {
      "chartData": _vm.crunchedWeatherCall
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeSpan[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeSpan),
      expression: "graphTimeSpan"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeSpan)
    },
    on: {
      "change": function($event) {
        return _vm.sliderChange()
      },
      "__r": function($event) {
        _vm.graphTimeSpan = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeSpan) + "/100%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xm-12 col-sm-3"
  }, [_c('label', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.labelTimeCenter[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xm-12 col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.graphTimeCenter),
      expression: "graphTimeCenter"
    }],
    staticClass: "custom-range",
    attrs: {
      "type": "range",
      "id": "customRange1"
    },
    domProps: {
      "value": (_vm.graphTimeCenter)
    },
    on: {
      "change": function($event) {
        return _vm.sliderChange()
      },
      "__r": function($event) {
        _vm.graphTimeCenter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.graphTimeCenter) + "/100%")])])])])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayNewGraph) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-9"
  }, [_c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "area",
      "height": "350",
      "options": _vm.chartOptions,
      "series": _vm.chartDataSeries
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-3 align-center"
  }, [_c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAvrPower),
      expression: "selectAvrPower"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAvrPower) ? _vm._i(_vm.selectAvrPower, null) > -1 : (_vm.selectAvrPower)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectAvrPower,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAvrPower = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAvrPower = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAvrPower = $$c
        }
      }, _vm.refreshNewGraphData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelSelectorAvrPowerKW[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectPeakPower),
      expression: "selectPeakPower"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.selectPeakPower) ? _vm._i(_vm.selectPeakPower, null) > -1 : (_vm.selectPeakPower)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectPeakPower,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectPeakPower = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectPeakPower = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectPeakPower = $$c
        }
      }, _vm.refreshNewGraphData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelSelectorPeakPowerKW[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectKWH),
      expression: "selectKWH"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.selectKWH) ? _vm._i(_vm.selectKWH, null) > -1 : (_vm.selectKWH)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectKWH,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectKWH = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectKWH = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectKWH = $$c
        }
      }, _vm.refreshNewGraphData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelSelectorKWHShort[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectCost),
      expression: "selectCost"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.selectCost) ? _vm._i(_vm.selectCost, null) > -1 : (_vm.selectCost)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectCost,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectCost = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectCost = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectCost = $$c
        }
      }, _vm.refreshNewGraphData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelSelectorCostShort[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectCumSumKwh),
      expression: "selectCumSumKwh"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.selectCumSumKwh) ? _vm._i(_vm.selectCumSumKwh, null) > -1 : (_vm.selectCumSumKwh)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectCumSumKwh,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectCumSumKwh = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectCumSumKwh = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectCumSumKwh = $$c
        }
      }, _vm.refreshNewGraphData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelSelectorCumSumKWHShort[_vm.actualLanguage]) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectCumSumCost),
      expression: "selectCumSumCost"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.selectCumSumCost) ? _vm._i(_vm.selectCumSumCost, null) > -1 : (_vm.selectCumSumCost)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectCumSumCost,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectCumSumCost = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectCumSumCost = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectCumSumCost = $$c
        }
      }, _vm.refreshNewGraphData]
    }
  }), _vm._v(" "), _c('span'), _vm._v(" " + _vm._s(_vm.labelSelectorCumSumCostShort[_vm.actualLanguage]) + "\n              ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center"
  }, [_c('download-csv', {
    staticClass: "btn btn-default",
    attrs: {
      "data": _vm.portData.slice(_vm.graphStartIndex, _vm.graphLastIndex),
      "name": "ChannelMeasurementData.csv"
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonDownloadData[_vm.actualLanguage]))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "block-content text-left"
  }, [(_vm.profileData.rights.rights.dashboardDataTableFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.textSectionTableau[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('data-table', {
    attrs: {
      "tableData": _vm.portData.slice(_vm.graphStartIndex, _vm.graphLastIndex)
    }
  })], 1)])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22856b7e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/SubComponents/PortGraph.vue
// module id = 1510
// module chunks = 4